import { externalConnectionConverter as _externalConnectionConverter } from '@griply/services';
import { ExternalConnection } from '@griply/types';
import { FirestoreDataConverter } from 'firebase/firestore';

export const externalConnectionsConverter =
  _externalConnectionConverter as unknown as FirestoreDataConverter<ExternalConnection>;
